<template>
  <div
      v-show="ready"
      class="el-carousel__item"
      :class="{
      'is-active': active,
      'el-carousel__item--card': $parent.type === 'card',
      'is-in-stage': inStage,
      'is-hover': hover,
      'is-animating': animating
    }"
      @click="handleItemClick"
      style="width: 286px;border-radius: 3px;box-shadow: 0 10px 10px 0 #ededed;"
      :style="itemStyle">
    <div
        v-if="$parent.type === 'card'"
        v-show="!active"
        class="el-carousel__mask">
    </div>
    <slot></slot>
  </div>
</template>

<script>
import {autoprefixer} from 'element-ui/src/utils/util';

const CARD_SCALE = 0.83;
const CARD_SCALE2 = 0.73;
const CARD_SCALE3 = 0.65;
const CARD_SCALE4 = 0.58;
export default {
  name: 'ElCarouselItem',

  props: {
    name: String,
    label: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      hover: false,
      translate: 0,
      scale: 1,
      active: false,
      ready: false,
      inStage: false,
      animating: false,
      zzIndex: 0,
    };
  },

  methods: {
    processIndex(index, activeIndex, length) {
      console.log("===================");
      console.log(index, activeIndex, length);
      console.log("===================");
      if (activeIndex === 0) {
        return index === 1 ? 1 : index === 2 ? 2 : index === 3 ? 3 : index === 4 ? -3 : index === 5 ? -2 : index === 6 ? -1 : 0
      }
      if (activeIndex === 1) {
        return index === 2 ? 1 : index === 3 ? 2 : index === 4 ? 3 : index === 5 ? -3 : index === 6 ? -2 : index === 0 ? -1 : 0
      }
      if (activeIndex === 2) {
        return index === 3 ? 1 : index === 4 ? 2 : index === 5 ? 3 : index === 6 ? -3 : index === 0 ? -2 : index === 1 ? -1 : 0
      }
      if (activeIndex === 3) {
        return index === 4 ? 1 : index === 5 ? 2 : index === 6 ? 3 : index === 0 ? -3 : index === 1 ? -2 : index === 2 ? -1 : 0
      }
      if (activeIndex === 4) {
        return index === 5 ? 1 : index === 6 ? 2 : index === 0 ? 3 : index === 1 ? -3 : index === 2 ? -2 : index === 3 ? -1 : 0
      }
      if (activeIndex === 5) {
        return index === 6 ? 1 : index === 0 ? 2 : index === 1 ? 3 : index === 2 ? -3 : index === 3 ? -2 : index === 4 ? -1 : 0
      }
      if (activeIndex === 6) {
        return index === 0 ? 1 : index === 1 ? 2 : index === 2 ? 3 : index === 3 ? -3 : index === 4 ? -2 : index === 5 ? -1 : 0
      }

      // if (activeIndex === 0 && index === length - 1) {
      //   return -1;
      // } else if (activeIndex === length - 1 && index === 0) {
      //   return length;
      // } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
      //   return length + 1;
      // } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
      //   return -2;
      // }
      // return index;
    },

    calcCardTranslate(index, activeIndex) {
      // const distance = this.$parent.$el.offsetWidth;
      // return distance * (index - activeIndex);
      console.log(index + "???????????")
      const parentWidth = this.$parent.$el.offsetWidth;
      const compWidth = 286;
      switch (index) {
        case -3:
          return parentWidth / 2 - compWidth / 2 - CARD_SCALE * compWidth / 2 - CARD_SCALE2 * compWidth / 2 - CARD_SCALE3 * compWidth / 2;
        case -2:
          return parentWidth / 2 - compWidth / 2 - CARD_SCALE * compWidth / 2 - CARD_SCALE2 * compWidth / 2;
        case -1:
          return parentWidth / 2 - compWidth / 2 - CARD_SCALE * compWidth / 2;
        case 0:
          return parentWidth / 2 - compWidth / 2;
        case 1:
          return parentWidth / 2 - compWidth / 2 + CARD_SCALE * compWidth / 2;
        case 2:
          return parentWidth / 2 - compWidth / 2 + CARD_SCALE * compWidth / 2 + CARD_SCALE2 * compWidth / 2;
        case 3:
          return parentWidth / 2 - compWidth / 2 + CARD_SCALE * compWidth / 2 + CARD_SCALE2 * compWidth / 2 + CARD_SCALE3 * compWidth / 2;
      }
      // console.log(parentWidth + "----------")
      // console.log(compWidth + "----------")
      // console.log(parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 8)
      //
      //
      // return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 8;
      // if (this.inStage) {
      //   return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 4;
      // } else if (index < activeIndex) {
      //   return -(1 + CARD_SCALE) * parentWidth / 4;
      // } else {
      //   return (3 + CARD_SCALE) * parentWidth / 4;
      // }
    },

    calcTranslate(index, activeIndex, isVertical) {
      const distance = this.$parent.$el[isVertical ? 'offsetHeight' : 'offsetWidth'];
      return distance * (index - activeIndex);
    },

    translateItem(index, activeIndex, oldIndex) {
      const parentType = this.$parent.type;
      const parentDirection = this.parentDirection;
      const length = this.$parent.items.length;
      if (parentType !== 'card' && oldIndex !== undefined) {
        this.animating = index === activeIndex || index === oldIndex;
      }
      index = this.processIndex(index, activeIndex, length);
      if (parentType === 'card') {
        this.active = index === 0;
        this.scale = Math.abs(index) == 0 ? 1 : Math.abs(index) == 1 ? CARD_SCALE : Math.abs(index) == 2 ? CARD_SCALE2 : Math.abs(index) == 3 ? CARD_SCALE3 : CARD_SCALE4;
        this.translate = this.calcCardTranslate(index, activeIndex);
        this.zzIndex = index
      } else {
        this.active = index === activeIndex;
        const isVertical = parentDirection === 'vertical';
        this.translate = this.calcTranslate(index, activeIndex, isVertical);
      }
      this.ready = true;
    },

    handleItemClick() {
      const parent = this.$parent;
      if (parent && parent.type === 'card') {
        const index = parent.items.indexOf(this);
        parent.setActiveItem(index);
      }
    }
  },

  computed: {
    parentDirection() {
      return this.$parent.direction;
    },

    itemStyle() {
      const translateType = this.parentDirection === 'vertical' ? 'translateY' : 'translateX';
      const value = `${translateType}(${this.translate}px) scale(${this.scale})`;
      // const value = `${translateType}(${this.translate}px) scale(${this.scale})`;
      let zIndex = 100 - Math.abs(this.zzIndex);
      let style
      if (this.active) {
        style = {
          'transform-origin': "center",
          'z-index': zIndex,
          transform: value,
          'background-color':"#3B85DA",
          'color':"#fff"
        };
      } else {
        style = {
          'transform-origin': "center",
          'z-index': zIndex,
          transform: value,
          'background-color':"#fff",
        };
      }
      return autoprefixer(style);
    }
  },

  created() {
    this.$parent && this.$parent.updateItems();
  },

  destroyed() {
    this.$parent && this.$parent.updateItems();
  }
};
</script>
